import { useSuspenseQuery } from '@tanstack/react-query';
import { faBarcode } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchAccountAddress } from 'api/account';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { accountQueryKeys } from 'queries/account-query-keys';

const LetterFoldPreview = () => {
    const { name, accountId, logo } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    const addressId = letter.sender_id;
    const { data: currentReturnAddress } = useSuspenseQuery({
        queryKey: accountQueryKeys.addressById(accountId, Number(addressId)),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchAccountAddress(accountId, addressId ?? 0),
                addressId !== null,
            ),
    });

    return (
        <div className="flex justify-between gap-4 pb-12 pt-4 uppercase">
            <div className={'flex h-full flex-col justify-between gap-14'}>
                <div className={'flex max-w-64 flex-col gap-1'}>
                    <div>
                        {currentReturnAddress && (
                            <div className={'flex flex-col'}>
                                <p className={'text-xs'}>{name}</p>
                                <p className={'text-xs'}>{currentReturnAddress.address_1}</p>
                                {currentReturnAddress.address_2 && (
                                    <p className={'text-xs'}>{currentReturnAddress.address_2}</p>
                                )}
                                <p className={'text-xs'}>
                                    {currentReturnAddress.city}, {currentReturnAddress.state}{' '}
                                    {currentReturnAddress.zipcode}
                                </p>
                            </div>
                        )}
                        {!currentReturnAddress && (
                            <div className={'flex flex-col'}>
                                <p className={'text-xs'}>{name}</p>
                                <p className={'text-xs'}>Company address</p>
                                <p className={'text-xs'}>City, State ZIP code</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className={'flex max-w-96 flex-col'}>
                    <div className={'flex flex-col'}>
                        <p className={'text-xs'}>Recipient name</p>
                        <p className={'text-xs'}>Recipient address</p>
                        <p className={'text-xs'}>City, State ZIP code</p>
                    </div>
                    <div className="overflow-hidden whitespace-nowrap">
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                        <FontAwesomeIcon icon={faBarcode} />
                    </div>
                </div>
            </div>
            {logo && (
                <div className="mt-3.5 w-40">
                    <img src={logo} className="float-right max-h-40" alt={'Letter logo preview'} />
                </div>
            )}
        </div>
    );
};

export { LetterFoldPreview };
